<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-slider">
    <div class="tpl-slider__page">
      <div class="tpl-slider__card">
        <div class="tpl-slider__hero">
          <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-slider__logo" />
          <h1 class="tpl-slider__hero-title">{{ quiz.title }}<span class="tpl-slider__hero-dot">.</span></h1>
          <p v-if="quiz.sub_title" class="tpl-slider__hero-sub">{{ quiz.sub_title }}</p>
        </div>
        <div class="tpl-slider__body">
          <slot />
        </div>
      </div>

      <footer class="tpl-slider__footer">
        <a v-if="quiz.privacy_url" :href="quiz.privacy_url" target="_blank">
          {{ quiz.privacy_text || 'Privacy Policy' }}
        </a>
        <p v-if="quiz.legal_name" class="tpl-slider__footer-legal">
          {{ quiz.legal_name }}<template v-if="quiz.legal_id"> — {{ quiz.legal_id }}</template>
        </p>
        <p v-if="quiz.disclaimer" class="tpl-slider__footer-disclaimer">{{ quiz.disclaimer }}</p>
      </footer>
    </div>
  </div>
</template>
